import { DAM_API_URL } from "../../Constant";

const API_URI = DAM_API_URL;
export const Imageshare = `${API_URI}/public/share-by-id?shareFileId=`;
export const ImageShare2ndVersion = `${API_URI}/public/share-by-id`;
export const Fetchsubfolder = `${API_URI}/public/getAssets?folderId=`;
export const Emailvalidate = `${API_URI}/public/validate-email`;
export const Otpvalidation = `${API_URI}/public/share-by-id`;
export const Downloadimage = `${API_URI}/public/download-file`;
export const Singlefiledownload = `${API_URI}/public/download-sub-file?damFileId`;
export const AllCollection = `${API_URI}/public/download-file?`;
export const downloadfolders = `${API_URI}/public/download-file?`;
export const downloadCollection = `${API_URI}/public/downloadcollections`;
export const downloadSubfolders  = `${API_URI}/public/download-sub-folder`
export const downloadImagesWithExternalDetails = `${API_URI}/public/download-file-url`;
export const downloadAllSelectedImage = `${API_URI}/public/download-sub-file`;
export const DOWNLAOD_MULTIPLE_ASSET = `${API_URI}/public/download-asset`;
export const GET_INNER_FOLDER_DATA = `${API_URI}/public/getAsset`; 
export const GET_INSIDE_COLLECTION_DATA = `${API_URI}/public/collection`;  //apidam/
export const GETALLFILETYPEEXTENSION = `${API_URI}/public/file-type-extension`;
export const GET_THEME_DATA=`${API_URI}/public/brand-information`


 
export const DOWNLOAD_STATUS_API=`${API_URI}/public/download-status`
export const DOWNLOAD_READY_ASSETS_API=`${API_URI}/public/download`

export const UPDATE_BANDWIDTH=`${DAM_API_URL}/public/update-bandwidth`
